// Subscription list with status filter + pagination.

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getSubscriptions } from '../adminApi';
import { Loading, Err } from './Overview';
import { Pager, shortDate } from './Users';

const PAGE_SIZE = 50;
const STATUS = ['all', 'active', 'cancelled'];

export default function Subscriptions() {
    const [data, setData] = useState(null);
    const [err, setErr] = useState(null);
    const [status, setStatus] = useState('all');
    const [page, setPage] = useState(1);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            setData(null);
            try {
                const d = await getSubscriptions({ status, page, size: PAGE_SIZE });
                if (!cancelled) setData(d);
            } catch (e) {
                if (!cancelled) setErr(e?.message || 'Failed to load');
            }
        })();
        return () => { cancelled = true; };
    }, [status, page]);

    if (err) return <Err msg={err} />;

    return (
        <div>
            <h2 style={styles.h2}>Subscriptions</h2>
            <div style={styles.tabs}>
                {STATUS.map((s) => (
                    <button
                        key={s}
                        onClick={() => { setStatus(s); setPage(1); }}
                        style={{
                            ...styles.tab,
                            ...(status === s ? styles.tabActive : null),
                        }}
                    >
                        {s.charAt(0).toUpperCase() + s.slice(1)}
                    </button>
                ))}
            </div>

            {!data ? <Loading /> : (
                <>
                    <div style={styles.tableWrap}>
                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    <Th>User</Th><Th>Type</Th><Th>Purchased</Th>
                                    <Th>Last renewed</Th><Th>Next renew</Th>
                                    <Th>Expires</Th><Th>Cancelled</Th><Th align="right">Paid</Th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.items.map((s) => (
                                    <tr key={s.id}>
                                        <Td>
                                            <Link to={`/admin/users/${s.user_id}`} style={styles.link}>
                                                {s.email || `#${s.user_id}`}
                                            </Link>
                                            {s.user_name ? (
                                                <span style={{ color: '#888', marginLeft: 6 }}>
                                                    {s.user_name}
                                                </span>
                                            ) : null}
                                        </Td>
                                        <Td>{s.subscription_type_title || s.subscription_type_id || '—'}</Td>
                                        <Td>{shortDate(s.date_purchased)}</Td>
                                        <Td>{shortDate(s.date_last_renewed)}</Td>
                                        <Td>{shortDate(s.next_renew_at)}</Td>
                                        <Td>{shortDate(s.date_expires)}</Td>
                                        <Td>{s.canceled ? 'Yes' : 'No'}</Td>
                                        <Td align="right">{s.paid != null ? s.paid.toFixed(2) : '—'}</Td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <Pager
                        page={page}
                        size={PAGE_SIZE}
                        total={data.total}
                        onChange={setPage}
                    />
                </>
            )}
        </div>
    );
}

function Th({ children, align }) {
    return <th style={{ ...styles.th, textAlign: align || 'left' }}>{children}</th>;
}
function Td({ children, align }) {
    return <td style={{ ...styles.td, textAlign: align || 'left' }}>{children}</td>;
}

const styles = {
    h2: { marginTop: 0, color: '#222' },
    tabs: { display: 'flex', gap: 6, marginBottom: 12 },
    tab: { padding: '6px 14px', borderRadius: 16, border: '1px solid #ddd', background: '#fff', color: '#555', cursor: 'pointer', fontSize: 13 },
    tabActive: { background: '#d97447', borderColor: '#d97447', color: '#fff', fontWeight: 600 },
    tableWrap: { backgroundColor: '#fff', borderRadius: 12, overflow: 'hidden' },
    table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
    th: { padding: '10px 12px', borderBottom: '1px solid #eee', color: '#888', fontWeight: 600, fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.4 },
    td: { padding: '10px 12px', borderBottom: '1px solid #f3f3f3', color: '#222' },
    link: { color: '#d97447', textDecoration: 'none', fontWeight: 600 },
};
